"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _types = require("./types");

var _utils = require("../../utils");

require("./Icon.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Semantic vector graphics. */
function Icon(_ref) {
  var size = _ref.size,
      type = _ref.type,
      color = _ref.color,
      ariaLabel = _ref.ariaLabel,
      component = _ref.component,
      classNameProp = _ref.className,
      rest = _objectWithoutProperties(_ref, ["size", "type", "color", "ariaLabel", "component", "className"]);

  var icon = _types.iconsMap.get(type) || component;
  var iconProps = (0, _react.useMemo)(function () {
    return {
      fill: 'currentColor',
      width: '1em',
      height: '1em',
      focusable: false,
      'aria-hidden': true
    };
  }, []);
  var className = (0, _utils.getClassNames)(classNameProp, 'Icon', _defineProperty({}, "Icon-".concat(type), type));
  if (!icon) return null;
  return /*#__PURE__*/_react.default.createElement("i", _extends({}, rest, {
    className: className,
    "aria-label": ariaLabel,
    style: {
      fontSize: "".concat(size, "px"),
      color: color
    }
  }), icon.render(iconProps));
}

Icon.propTypes = {
  /** Can be set to 'questionmark', 'verified', 'error',
   * 'infobox', 'link' etc. for custom theme.
   * See more on the link to the additional ant design props. */
  type: _propTypes.default.string,

  /** Icon size in pixels. Should be a number */
  size: _propTypes.default.number,

  /** Style the icon with color */
  color: _propTypes.default.string,

  /** The aria-label for icon */
  ariaLabel: _propTypes.default.string,

  /** Custom component that can be displayed as icon
   * (can be used optionally instead of 'type' property) */
  component: _propTypes.default.node,

  /** Custom class name */
  className: _propTypes.default.string
};
Icon.defaultProps = {
  type: null,
  size: '1em',
  color: null,
  ariaLabel: null,
  component: null,
  className: null
};
var _default = Icon;
exports.default = _default;